
import React, { useEffect, useState } from "react";
import { Button, FormGroup, FormLabel, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import useTranslation from "../../Hooks/UseTranslation";

import TasksActions from "../../Redux/Actions/TasksActions";

import InputFormControl from "../InputFormControl/InputFormControl";
import InputSelect from "../ProgrammationManager/components/InputSelect";

import Times from "../SvgImages/Times";

import './AddRestrictionToMany.scss'

interface AddRestrictionToManyProps {
  show: boolean;
  tasks: any[]
  onCancel: () => void;
  onSaved: () => void;
}

const AddRestrictionToMany = (props: AddRestrictionToManyProps) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { users } = useSelector((state: any) => state.ProgrammationReducer)

  const [ tasks, setTasks ] = useState(props.tasks)

  const [ description, setDescription ] = useState('')
  const [ family, setFamily ] = useState('general')
  const [ responsible, setResponsible ] = useState('')

  const [ saving, setSaving ] = useState(false)

  const familiesOptions = [
    { _id: 'general', name: t('CONSTRAINT_CREATOR:FamilyGeneral') },
    { _id: 'coordination', name: t('CONSTRAINT_CREATOR:FamilyCoordination') },
    { _id: 'resource', name: t('CONSTRAINT_CREATOR:FamilyResource') },
    { _id: 'time', name: t('CONSTRAINT_CREATOR:FamilyTime') },
    { _id: 'space', name: t('CONSTRAINT_CREATOR:FamilySpace') },
    { _id: 'design', name: t('CONSTRAINT_CREATOR:FamilyDesign') },
    { _id: 'logistic', name: t('CONSTRAINT_CREATOR:FamilyLogistic') },
  ]

  const handleSubmit = async () => {

    if (!description) return

    setSaving(true)

    const tasks_ids = tasks.map(task => task._id)

    await dispatch(TasksActions.addRestrictionToMany(tasks_ids, { description, family, responsible }))

    setSaving(false)
    setDescription('')

    props.onSaved()
  }

  const handleRemoveTask = async (index: number) => {

    const filtered = tasks.filter((task: any, i: number) => i !== index)

    setTasks(filtered)

    if (!filtered.length) {

      props.onCancel()
    }
  }

  useEffect(() => {

    setTasks(props.tasks)
  }, [props.tasks, props.show])

  return (
    <Modal
      show={props.show}
      onHide={props.onCancel}
      dialogClassName="add-restriction-to-many-modal"
    >
      <Modal.Header>
        <Modal.Title>
          {t('ADD_RESTRICTION_TO_MANY:Title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            {t('ADD_RESTRICTION_TO_MANY:Content')}
          </p>
          <ListGroup className="tasks-list">
            {tasks.map((task, index) => (
              <div key={index} className="tasks-list-item">
                <div className="tasks-list-item-name">
                  {task.name}
                </div>
                <div className="tasks-list-item-buttons">
                  <button
                    className="tasks-list-item-button"
                    onClick={() => handleRemoveTask(index)}
                  >
                    <Times
                      height={20}
                      width={20}
                    />
                  </button>
                </div>
              </div>
            ))}
          </ListGroup>
          <FormGroup>
            <FormLabel>
              {t('ADD_RESTRICTION_TO_MANY:DescriptionLabel')}
            </FormLabel>
            <InputFormControl
              value={description}
              onChange={setDescription}
              readOnly={saving}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {t('ADD_RESTRICTION_TO_MANY:FamilyLabel')}
            </FormLabel>
            <InputSelect
              value={family}
              options={familiesOptions}
              onChange={setFamily}
            />
          </FormGroup>
            <FormGroup className='mb-4'>
              <FormLabel>
                {t('ADD_RESTRICTION_TO_MANY:ResponsibleLabel')}
              </FormLabel>
              <InputSelect
                placeholder="Responsible"
                value={responsible}
                options={users.map((u: any) => ({ _id: u._id, name: `${u.name} (${u.surname})` }))}
                onChange={setResponsible}
              />
            </FormGroup>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-primary" onClick={() => handleSubmit()} disabled={!description || saving}>
          <span className="icon-guardar" ></span> {saving ? t('ADD_RESTRICTION_TO_MANY:SavingButton') : t('ADD_RESTRICTION_TO_MANY:SaveButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddRestrictionToMany;
